// extracted by mini-css-extract-plugin
export default {"modal":"game_modal__ezM+9","container":"game_container__KTFZG","show":"game_show__UPh0e","btn":"game_btn__Hh7oF"};